import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { UnleashService } from '../services/unleash/unleash.service';

@Directive({
  selector: '[appUnleashFeature]'
})
export class UnleashFeatureDirective implements OnInit, OnDestroy {
  @Input('appUnleashFeature') featureName!: string;
  @Input() hideWhenDisabled: boolean = true; // Default behavior: hide when feature is disabled
  @Input() showWhenDisabled: boolean = false; // Alternative: show when feature is disabled

  private originalDisplay: string = '';

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private unleashService: UnleashService
  ) {}

  ngOnInit(): void {
    if (!this.featureName) {
      console.warn('UnleashFeatureDirective: featureName is required');
      return;
    }

    // Store the original display style
    this.originalDisplay = this.elementRef.nativeElement.style.display || '';

    this.updateElementVisibility();
  }

  ngOnDestroy(): void {
    // Restore original display style when directive is destroyed
    if (this.originalDisplay) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', this.originalDisplay);
    }
  }

  private updateElementVisibility(): void {
    const isFeatureEnabled = this.unleashService.isEnabled(this.featureName);
    
    if (this.hideWhenDisabled && !this.showWhenDisabled) {
      // Default behavior: hide when feature is disabled
      if (isFeatureEnabled) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', this.originalDisplay || '');
      } else {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
      }
    } else if (this.showWhenDisabled && !this.hideWhenDisabled) {
      // Alternative behavior: show when feature is disabled
      if (!isFeatureEnabled) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', this.originalDisplay || '');
      } else {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
      }
    } else {
      // If both or neither are set, default to hide when disabled
      if (isFeatureEnabled) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', this.originalDisplay || '');
      } else {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
      }
    }
  }
}
